// JavaScript for slider functionality
// Get references to the elements
let currentIndex = 0;

function nextSlide() {
  var slider = document.querySelector(".recommendation-slider");
  var sliderItems = document.querySelectorAll(".slider-item");
  currentIndex = (currentIndex + 1) % sliderItems.length;
  updateSlider();
}

function prevSlide() {
  var slider = document.querySelector(".recommendation-slider");
  var sliderItems = document.querySelectorAll(".slider-item");
  currentIndex = (currentIndex - 1 + sliderItems.length) % sliderItems.length;
  updateSlider();
}

function updateSlider() {
  var slider = document.querySelector(".recommendation-slider");
  var sliderItems = document.querySelectorAll(".slider-item");
  var translateX = -currentIndex * 100; // Adjust 100 for item width
  slider.style.transform = `translateX(${translateX}%)`;
}